module.exports = __webpack_public_path__ + "static/media/location-map.22550ced.svg";